<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Media List</h4>
            <!-- {{ Categories.data }} -->
            <!-- <h6>Manage Your Subscription Plans</h6> -->
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a
                ref="collapseHeader"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Collapse"
                @click="toggleCollapse(collapseHeader.value)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="openModal('new')"
          >
            <vue-feather type="plus-circle" class="me-2"></vue-feather>
            Add Media
          </a>
        </div>
      </div>
      <!-- USER TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="media.columns"
          :data="media.data.value"
          :filters="media.filters"
          :row-selection="rowSelection"
      >
        <template #header>
          <h4>Available Media</h4>
        </template>

        <template #rightHeader="{ filteredData }">
          <button v-if="selectedRowKeys.length > 0"
              class="btn btn-danger"
              :disabled="selectedRowKeys.length === 0"
              @click="bulkDelete"
          >
            Delete Selected ({{ selectedRowKeys.length }})
          </button>
        </template>

        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'url'">
            <div class="">
              <a href="javascript:void(0);" class="">
                <Avatar
                    :src="record.url"
                    :alt="record.title"
                    :shape="shape"
                    :size="240"
                    img-class="user-image"
                />
              </a>

            </div>
          </template>

          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">
                <a @click="openModal('update', record.id)" class="me-2 p-2 mb-0">
                  <i data-feather="edit" class="feather-edit"></i>
                </a>
                <a
                    @click="deleteMedia(record.id)"
                    class="me-2 confirm-text p-2 mb-0"
                    href="javascript:void(0);"
                >
                  <i data-feather="trash-2" class="feather-trash-2"></i>
                </a>
              </div>
            </td>
          </template>
        </template>

        <!-- </template> -->
      </filter-table>
      <!-- USER TABLE -->
    </div>
  </div>

  <MediaModal :media-id="selectedMediaId" ref="uploadMediaModal"/>

</template>

<script setup>

import MediaModal from "./modal/media-modal.vue";
import {computed, onMounted, ref} from "vue";
import {useMediaStore} from "@/store/mediaStore";
import {confirm} from "@/utils/swal";
import {toggleCollapse} from "@/utils/components";
import Avatar from "@/components/avatar.vue";
import PodcastCatModal from "@/views/pages/podcast/modal/podcast-category-modal.vue";

const mediaStore = useMediaStore();

// data
/**
 * Id of Plan that is being edited
 */
const selectedMediaId = ref(null);
const media = {
  filters: ["title", "file_type", "date"],
  columns: [
    {
      title: "Image",
      dataIndex: "url",
      key: "url",
      sorter: {
        compare: (a, b) => {
          a = a.name.toLowerCase();
          b = b.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      sorter: {
        compare: (a, b) => {
          a = a.description.toLowerCase();
          b = b.description.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "description",
      dataIndex: "description",
      key: "description",
      sorter: {
        compare: (a, b) => {
          a = a.description.toLowerCase();
          b = b.description.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "file type",
      dataIndex: "file_type",
      key: "file_type",
      sorter: {
        compare: (a, b) => {
          a = a.file_type.toLowerCase();
          b = b.file_type.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "date",
      dataIndex: "date",
      key: "date",
      sorter: {
        compare: (a, b) => {
          a = a.date.toLowerCase();
          b = b.date.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },

    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => mediaStore.media),
};

const selectedRowKeys = ref([]);
const selectedRows = ref([]);

const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys, rows) => {
    selectedRowKeys.value = keys,
        selectedRows.value = rows;
  },
}));



// ref elements
const collapseHeader = ref(null);

// avatar shape
const shape = ref('square');

// Methods
async function deleteMedia(id) {
  confirm({
    title: "Are you sure about this?",
    message: "This media will be deleted",
    callback: async (continueDelete) => {
      if (continueDelete) {
        await mediaStore.deleteMedia(id);
      }
    },
  });
}

async function bulkDelete() {
  if (selectedRowKeys.value.length === 0) return;

  confirm({
    title: "Delete selected media?",
    message: `You are about to delete ${selectedRowKeys.value.length} items.`,
    callback: async (continueDelete) => {
      if (continueDelete) {
        console.log('mediaStore', mediaStore);
        console.log('has bulkDelete?', typeof mediaStore.bulkDelete, Object.keys(mediaStore || {}));
        await mediaStore.bulkDelete(selectedRowKeys.value);
        selectedRowKeys.value = [];
        selectedRows.value = [];
      }
    },
  });
}

function openModal(action, id = null) {
  if (action === "update") {
    selectedMediaId.value = id;
  } else {
    selectedMediaId.value = null;
  }
  $("#uploadMediaModal").modal("show");
}

async function handlePageChange(newPage) {
  await mediaStore.fetchMedia(newPage);
}

onMounted(async () => {
  if (media.data.value.length === 0) {
    await mediaStore.fetchMedia();
  }
});


</script>

<style scoped>
.userimgname {
  display: flex;
  align-items: center;
  gap: 12px;
}

.userslist-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>